<template>
  <div class="backend-role">
    <section class="top-wrap">
      <div class="main-title">应用角色</div>
      <div class="right">
        <el-button type="primary" size="small" @click="dialogVisible = true">新建</el-button>
      </div>
    </section>
    <section class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <BaseTable
        v-else
        ref="BaseTable"
        :tableHeight="tableHeight"
        :tableColumns="tableColumns"
        :tableData="roles"
        :pageInfo="pageInfo"
        from="app"
      >
        <template v-slot:table-suffix>
          <el-table-column prop="handle" label="操作" width="160">
            <template v-slot="scope">
              <el-button
                v-if="scope.row.name !== '管理员'"
                @click.stop="toEditRole(scope.row)"
                type="text"
                size="mini"
              >
                编辑
              </el-button>
              <el-button
                v-if="!scope.row.special"
                @click.stop="deleteRole(scope.row)"
                type="text"
                size="mini"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </template>
      </BaseTable>

      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        top="0"
        width="560px"
        class="role-create-dialog"
        append-to-body
      >
        <el-form :model="role" :rules="rules" label-width="80px" ref="roleForm">
          <el-form-item label="角色名称" prop="name">
            <el-input v-model="role.name" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述" prop="description">
            <el-input
              v-model="role.description"
              :autosize="{ minRows: 2, maxRows: 6 }"
              type="textarea"
              resize="none"
              placeholder="请添加角色描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="createRole(role)">创 建</el-button>
        </span>
      </el-dialog>
    </section>
    <role-setting
      :visible.sync="roleModalVisible"
      :sheets="sheetDefs"
      :role="selectedRole"
      :boards="dashBoards"
      @submit="updateRole"
    ></role-setting>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import TableController from "@/views/Backend/Admin/Layout/mixin/TableController"
import { tableColumns } from "./static"
import * as roleApi from "@/api/appManage/role"
import { getAllSheet } from "@/api/sheet/sheet"
import { getManageDashboardList } from "@/api/appManage/statistics"
import RoleSetting from "./role-setting"

export default {
  name: "backend-role",
  components: {
    BaseTable,
    RoleSetting
  },
  inject: ["app"],
  data() {
    return {
      tableColumns,
      role: {},
      roles: [],
      dialogVisible: false,
      roleModalVisible: false,
      selectedRole: {},
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      sheetDefs: null,
      dashBoards: [],
      loadingItems: {
        data: true
      },
      rules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }]
      }
    }
  },
  mixins: [TableController],
  created() {
    getAllSheet(this.app.id).then(sheetDefs => (this.sheetDefs = sheetDefs))
    getManageDashboardList(this.app.id).then(dashboardList => (this.dashBoards = dashboardList))
    this.refresh()
  },
  computed: {
    loadingRoles() {
      return !this.sheetDefs || this.roles.length === 0
    }
  },
  methods: {
    refresh() {
      this.loadingItems.data = true
      this.roleModalVisible = false
      this.dialogVisible = false
      this.roles = []
      roleApi.getRolesWithNum(this.app.id).then(data => {
        this.roles = data
        this.loadingItems.data = false
        this.resetPageInfo(this.roles)
      })
    },
    createRole(role) {
      roleApi.createRole(role, this.app.id).then(() => {
        this.$message.success("操作成功")
        this.$refs["roleForm"].resetFields()
        this.refresh()
      })
    },
    toEditRole(row) {
      this.selectedRole = row
      this.roleModalVisible = true
    },
    deleteRole(role) {
      roleApi.deleteRole(role.id).then(res => {
        if (res.data.code !== 0) {
          this.$message({
            message: res.data.msg,
            type: "error"
          })
          return
        }
        this.refresh()
      })
    },
    updateRole(role) {
      roleApi.updateRole(role).then(() => {
        this.$message.success("角色编辑成功！")
        this.refresh()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.backend-export {
  .empty {
    height: 100%;
    width: 100%;
  }

  .right ::v-deep {
    .el-input-group__append {
      padding: 0 10px;
    }
  }
}
</style>

<style lang="scss">
.role-create-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-dialog {
    margin-bottom: 50px;
    border-radius: 8px;
  }

  .el-dialog__header {
    padding: 20px 24px 18px;
  }

  .el-dialog__body {
    margin-top: 10px;
    overflow: auto;
    padding: 0 22px;
    color: #9e9e9e;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
